export enum WeightUnit {
  GRAMS = 'g',
  OUNCES = 'oz',
  POUNDS = 'lb',
  KILOGRAMS = 'kg'
}
